<template>
    <div id="generate-report">
        <section class="box-container">
            <section class="loading-container">
                <div class="_loading" slot="content" v-if="progress !== 100"/>

                <span class="generate-complete" v-else>
                    Successfully Generated Report!
                </span>

                <section class="loading-progress">
                    <div class="progress" :style="`width: ${progress}%`"/>
                </section>

                <section class="generate-label">
                    <span class="generate-title">
                        {{ progress === 100 ? 'Generated Report' : 'Generating Report' }}
                    </span>

                    <span class="generate-title">
                        {{ `${progress} %` }}
                    </span>
                </section>
            </section>
        </section>

        <html2-pdf-generator
			:testGenerator="false"
			splitImgByHeight="1000"
            @progress="setProgress($event)"
            @hasDownloaded="hasDownloadedPDF()"
			ref="html2PdfGenerator"
		>
			<report-template
                slot="img-content"
                :filename="`${reportData ? reportData.name : ''} - Report`"
                @domRendered="templateHasRendered()"
                :reportData="reportData"
                v-if="reportData"
            />
		</html2-pdf-generator>
    </div>
</template>

<script>
import Html2PdfGenerator from '@/components/utils/HTML2PdfGenerator.vue'
import ReportTemplate from '@/components/user-profile/ReportTemplate.vue'

export default {
	async created () {
		await this.getGeneratePdfData()
	},

	data () {
		return {
			progress: 0,
			reportData: null

		}
	},

	methods: {
		/* Created Lifecycle Methods */
		async getGeneratePdfData () {
			try {
				const reportData = localStorage.getItem('reportData')
				if (!reportData) {
					this.onReportDataError()
					return
				}

				this.reportData = JSON.parse(reportData).data

				this.progress = 10
			} catch (error) {
				this.onReportDataError()
			}
		},

		onReportDataError () {
			window.close()
			this.$router.push('/')
			localStorage.removeItem('reportData')
		},

		/* Template Methods */
		setProgress (progress) {
			this.progress = progress
		},

		async templateHasRendered () {
			this.progress = 20

			try {
				this.$refs.html2PdfGenerator.generatePdf()
			} catch (error) {
				this.onReportDataError()
			}
		},

		hasDownloadedPDF () {
			localStorage.removeItem('reportData')

			setTimeout(async () => {
				window.close()
			}, 1200)
		}
	},

	components: {
		Html2PdfGenerator,
		ReportTemplate
	}
}
</script>

<style lang="scss" scoped>
#generate-report {
    width: 100vw;
	height: 100vh;
	display: flex;
	justify-content: center;
	align-items: center;
    overflow: auto;
    padding: 50px 10px;
    background-color: #4CCBB6;
    background-repeat: no-repeat;
    background-size: cover;
    background-image: url('~@/assets/img/guest_bg.png');

    .box-container {
        padding: 25px;
        background: #fff;
        border-radius: 5px;
        width: 600px;
        height: 200px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        flex-shrink: 0;

        .loading-container {
            width: 100%;
            flex-shrink: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;

            .loading-progress {
                margin-top: 25px;
                width: 100%;
                height: 30px;
                border: 1px solid #e8e8e8;
                border-radius: 3px;
                flex-shrink: 0;

                .progress {
                    height: 100%;
                    background-color: #4CCBB6;
                    background-image: linear-gradient(to bottom, #4CCBB6 , #41C2C5) !important;
                    background-repeat: no-repeat;
                    background-size: cover;
                    width: 0%;
                    transition: 0.8s;
                }
            }

            .generate-complete {
                font-size: 16px;
                font-weight: 600;
            }

            .generate-label {
                margin-top: 15px;
                flex-shrink: 0;
                display: flex;
                justify-content: space-between;
                width: 100%;
            }
        }

        .error-container {
            width: 100%;
            flex-shrink: 0;
            display: flex;
            flex-direction: column;
            align-items: center;

            img {
                flex: 0 0 auto;
                width: 65px;
                height: 65px;
                margin-bottom: 15px;
            }
        }
    }
}
</style>
